import React, { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import styles from './LandscapeIndicatorContributionTemplate.module.css';
import { Button } from '../../atoms';
import { useNavigate, useParams } from 'react-router-dom';
import { LandscapeIndicatorValue } from '../../organisms';
import { ValueResponseDto } from '../../../store/landscapeAPI/value/dto/response/value-response.dto';
import LandscapeIndicatorBaseTemplate from '../../../templates/LandscapeIndicatorBaseTemplate';

interface LandscapeIndicatorContributionTemplateProps {
  data: ValueResponseDto[];
  handleDelete: (id: string) => void;
  handleUpdate: (id: string) => void;
}

const LandscapeIndicatorContributionTemplate: FC<
  LandscapeIndicatorContributionTemplateProps
> = ({ data, handleUpdate, handleDelete }) => {
  const navigate = useNavigate();
  const { id, landscapeIndicatorId } = useParams();

  return (
    <BaseTemplate>
      <LandscapeIndicatorBaseTemplate>
        <div className={styles.heading}>
          <Button
            variant={'dark'}
            onClick={() =>
              navigate(
                `/landscapes/edit/${id}/indicators/edit/${landscapeIndicatorId}/contribution/add`
              )
            }
          >
            Add Update
          </Button>
        </div>
        <LandscapeIndicatorValue
          data={data}
          handleUpdate={handleUpdate}
          handleDelete={handleDelete}
        />
      </LandscapeIndicatorBaseTemplate>
    </BaseTemplate>
  );
};

export default LandscapeIndicatorContributionTemplate;
